// src/constants/menus/icons.ts
import {
  HomeIcon,
  ExploreIcon,
  CommunityIcon,
  NotificationIcon,
  FolderIcon,
  FileIcon,
  ChartIcon,
  ShieldIcon,
  MoneyIcon,
  SettingsIcon,
  QuestionIcon,
  WarningIcon,
  UserShieldIcon,
  CopyrightIcon,
  ContractIcon,
  AddIcon,
  EditIcon,
  ListIcon,
  CreditCardIcon,
  UserConfigIcon,
  HistoryIcon,
  GlobalIcon,
  SearchIcon,
  BanIcon,
  ScaleIcon,
  GavelIcon,
  LockIcon,
  EditDocIcon,
  CheckIcon,
} from "../../components/icons/MenuIcons";

import {
  FaBook,
  FaCloudUploadAlt,
  FaFolder,
  FaFileInvoiceDollar,
  FaSearch,
  FaCertificate,
  FaStamp,
  FaGlobe,
  FaFlag,
  FaHandshake,
  FaClipboardCheck,
  FaHistory,
  FaShieldAlt,
  FaLink,
  FaStore,
  FaUpload,
  FaUsers,
  FaDollarSign,
  FaArchive,
  FaUserPlus,
  FaClipboardList,
  FaFileContract,
  FaGavel,
  FaWallet,
  FaMoneyCheckAlt,
  FaReceipt,
  FaUndo,
} from "react-icons/fa";

import { MdAddBox, MdPayment, MdAccountBalanceWallet } from "react-icons/md";
import { BiPurchaseTag, BiStats, BiTrendingUp } from "react-icons/bi";
import { HiCollection, HiCash, HiDocumentSearch } from "react-icons/hi";
import { AiOutlineLineChart } from "react-icons/ai";

export const MenuIcons = {
  // Core Icons
  Home: HomeIcon,
  Explore: ExploreIcon,
  Community: CommunityIcon,
  Notification: NotificationIcon,
  Folder: FolderIcon,
  File: FileIcon,
  Chart: ChartIcon,
  Shield: ShieldIcon,
  Money: MoneyIcon,
  Settings: SettingsIcon,
  Question: QuestionIcon,
  Warning: WarningIcon,
  UserShield: UserShieldIcon,
  Copyright: CopyrightIcon,
  Contract: ContractIcon,
  Add: AddIcon,
  Edit: EditIcon,
  List: ListIcon,
  CreditCard: CreditCardIcon,
  UserConfig: UserConfigIcon,
  History: HistoryIcon,
  Global: GlobalIcon,
  Search: SearchIcon,
  Ban: BanIcon,
  Scale: ScaleIcon,
  Gavel: GavelIcon,
  Lock: LockIcon,
  EditDoc: EditDocIcon,
  Check: CheckIcon,

  // Feature Icons
  Book: FaBook,
  CloudUpload: FaCloudUploadAlt,
  FolderAlt: FaFolder,
  Invoice: FaFileInvoiceDollar,
  SearchAlt: FaSearch,
  Certificate: FaCertificate,
  Stamp: FaStamp,
  Globe: FaGlobe,
  Flag: FaFlag,
  Handshake: FaHandshake,
  ClipboardCheck: FaClipboardCheck,
  HistoryAlt: FaHistory,
  ShieldAlt: FaShieldAlt,
  Link: FaLink,
  Store: FaStore,
  Upload: FaUpload,
  Users: FaUsers,
  Dollar: FaDollarSign,
  Archive: FaArchive,
  UserPlus: FaUserPlus,
  ClipboardList: FaClipboardList,
  FileContract: FaFileContract,
  GavelAlt: FaGavel,
  Wallet: FaWallet,
  MoneyCheck: FaMoneyCheckAlt,
  Receipt: FaReceipt,
  Undo: FaUndo,

  // MD Icons
  AddBox: MdAddBox,
  Payment: MdPayment,
  AccountBalance: MdAccountBalanceWallet,

  // BI Icons
  PurchaseTag: BiPurchaseTag,
  Stats: BiStats,
  Trending: BiTrendingUp,

  // HI Icons
  Collection: HiCollection,
  Cash: HiCash,
  DocumentSearch: HiDocumentSearch,
  
  // AI Icons
  Activity: AiOutlineLineChart,
};